// src/pages/Clients/components/ClientsTab.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Table, Popconfirm, App, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchClients, removeClient } from "../clientsSlice";
import { getAccessType } from "../../../lib/functions";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useIsAdminUser } from "../../../lib/accessList";

const ClientsTab = ({ onCreate, onEdit }) => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { clients, loading } = useSelector((s) => s.clientsSuite);

  let [access_type, access_type_set] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const isAdminUser = useIsAdminUser();

  const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  useEffect(() => {
    const access = getAccessType("clients_entry");
    access_type_set(access);
  }, []);

  const columns = useMemo(
    () => [
      { title: "Client Name", dataIndex: "name", key: "name" },
      { title: "Latitude", dataIndex: "latitude", key: "latitude" },
      { title: "Longitude", dataIndex: "longitude", key: "longitude" },
      ...(access_type === "WRITE"
        ? [
          {
            title: "Actions",
            key: "actions",
            align: "right",
            render: (_, row) => (
              <>
                <Button
                  type="link"
                  icon={<EditOutlined />}
                  disabled={!(isAdminUser || canEdit)}
                  onClick={() => onEdit(row)}
                />

                <Popconfirm
                  title="Delete client?"
                  okText="Delete"
                  onConfirm={async () => {
                    await dispatch(removeClient(row.id));
                    message.success("Client deleted");
                    dispatch(fetchClients());
                  }}
                >
                  {/* <a style={{ color: "#ff4d4f" }}>Delete</a> */}
                  <Button
                    type="link"
                    danger
                    disabled={!(isAdminUser || canDelete)}
                    icon={<DeleteOutlined />}
                  />
                </Popconfirm>
              </>
            ),
          },
        ]
        : []),
    ],
    [dispatch, onEdit],
  );

  return (
    <Table
      rowKey="id"
      dataSource={clients}
      columns={columns}
      loading={loading.clients}
      scroll={{ x: "max-content" }}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: clients?.length,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        onChange: (page) => {
          setCurrentPage(page);
        },
        onShowSizeChange: (_, size) => {
          setPageSize(size);
          setCurrentPage(1);
        },
      }}
    />
  );
};

export default ClientsTab;
